import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"

interface ActionButtonsProps {
  onDone: () => void
  onCancel: () => void
  showDoneTooltip?: boolean
  showCancelTooltip?: boolean
  setShowDoneTooltip?: (show: boolean) => void
  setShowCancelTooltip?: (show: boolean) => void
  doneAriaLabel?: string
  cancelAriaLabel?: string
  className?: string
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onDone,
  onCancel,
  showDoneTooltip = false,
  showCancelTooltip = false,
  setShowDoneTooltip,
  setShowCancelTooltip,
  doneAriaLabel = 'Save changes',
  cancelAriaLabel = 'Cancel changes',
  className = ''
}) => {
  const defaultDoneButtonRef = useRef<HTMLButtonElement>(null)
  const defaultCancelButtonRef = useRef<HTMLButtonElement>(null)

  const doneButtonRef = useRef<HTMLButtonElement>(null)
  const cancelButtonRef = useRef<HTMLButtonElement>(null)

  const doneRef = doneButtonRef || defaultDoneButtonRef
  const cancelRef = cancelButtonRef || defaultCancelButtonRef

  return (
    <div className={`button-group ${className}`}>
      <div className="button-container">
        <button
          ref={doneRef}
          className="action-button done-button"
          onClick={onDone}
          onMouseEnter={() => setShowDoneTooltip && setShowDoneTooltip(true)}
          onMouseLeave={() => setShowDoneTooltip && setShowDoneTooltip(false)}
          aria-label={doneAriaLabel}
        >
          <Icon
            name={IconName.Done}
            className="action-icon done-icon"
            width="20"
            height="20"
          />
          Done
        </button>

        {showDoneTooltip && (
          <div className="action-tooltip">
            Done
          </div>
        )}
      </div>

      <div className="button-container">
        <button
          ref={cancelRef}
          className="action-button cancel-button"
          onClick={onCancel}
          onMouseEnter={() => setShowCancelTooltip && setShowCancelTooltip(true)}
          onMouseLeave={() => setShowCancelTooltip && setShowCancelTooltip(false)}
          aria-label={cancelAriaLabel}
        >
          <Icon
            name={IconName.Cancel}
            className="action-icon cancel-icon"
            width="20"
            height="20"
          />
          Cancel
        </button>

        {showCancelTooltip && (
          <div className="action-tooltip">
            Cancel
          </div>
        )}
      </div>
    </div>
  )
}
